import { A11yModule } from '@angular/cdk/a11y'
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { FocusableNoopAnchorDirective, IconComponent } from '@ftr/foundation'
import { SideNavItemInnerComponent } from './side-nav-item/side-nav-item-inner.component'
import { SideNavItemComponent } from './side-nav-item/side-nav-item.component'
import { SideNavComponent } from './side-nav.component'

@NgModule({
  imports: [CommonModule, IconComponent, RouterModule, A11yModule, FocusableNoopAnchorDirective],
  declarations: [SideNavComponent, SideNavItemComponent, SideNavItemInnerComponent],
  exports: [SideNavComponent],
})
export class SideNavModule {}
